module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ExtraBold.81a6f25.eot";